import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AccountNumberPipe } from '../../../shared/pipes/account-number.pipe';

@Component({
    selector: 'app-account-cell-renderer',
    template: `<span [innerText]="accountNumber | accountNumber"></span>`,
    standalone: true,
    imports: [AccountNumberPipe]
})
export class AccountCellRendererComponent implements ICellRendererAngularComp {
  private params: ICellRendererParams;
  accountNumber: string;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.accountNumber = params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }
}
